<template >
  <div ref="products">
    <div class="orderbys flex items-center ">
      <div v-for="item in orderbys" :key="item.key" @click="selectOrderby(item.key)"
        class="pr-9 text-l  flex items-center cursor-pointer"
        :class="{ 'text-main': orderby && orderby.includes(item.key) }">
        {{ item.name }}
        <span class="iconfont icon-zhankai  pl-1" v-if="orderby && orderby.includes(item.key)"
          :class="{ 'up': orderby == item.key }"></span>
      </div>
    </div>
    <div class="products pt-4" v-if="products">
      <div class="left" v-if="pager.total">
        <div class="product bg-white pb-3 flex flex-col items-start hover:shadow-lg" v-for="item in products.items"
          :key="item.id" @click="$goTo('/product/detail/' + item.id)">
          <div class="img-box cursor-pointer">
            <img :src="$firstImage(item.images, 'normal')" class="img" :onerror="defaultUrl">
            <div class="status absolute z-10 inset-0 " v-if="item.status != 10 || !item.stock">
              <span class=" iconfont icon-yixiajia" v-if="item.status == 0"></span>

              <span class="iconfont icon-yishouqing" v-else-if="!item.stock"></span>
            </div>
          </div>
          <div class="pt-2 font-semibold text-l px-2">
            {{ item.name }}
          </div>
          <div class="attrs flex  text-left break-all px-2">
            {{ item.attribute_text }}
          </div>
          <div class="space-x-4 px-2">
            <span class="text-sm text-gray-400 whitespace-nowrap">{{ $t('库存') }}：{{ item.stock }}</span>
            <span class="text-sm text-gray-400 whitespace-nowrap">{{ $t('已售') }}：{{ item.sales }}</span>
          </div>
          <div>
          </div>
          <div class="px-2 pt-4 flex justify-between w-full items-center">
            <span class="price">{{ $p(item.price) }}</span>
            <el-button size="small" type="primary" @click.stop="addCart(item)">{{ $t('采购') }}</el-button>
          </div>
        </div>
        <el-pagination class="col-start-1 col-end-5" background layout="prev, pager, next" :total="pager.total"
          @current-change="pageChange" :page-size="20">
        </el-pagination>
      </div>
      <img src="@/assets/image/暂无数据.png" v-else class="m-auto">
      <div class="right relative" ref="orderBlank">
        <div class=" bg-white" :class="{ is_fixed_top: isFixedTop, is_fixed_bottom: isFixedBottom }" ref="boxFixed">
          <div class="title bg-main text-white py-3">{{ $t('配货单') }}</div>
          <div class="tables" ref="scroll">
            <table ref="scrollChild">
              <tr class="tr">
                <th v-for="(th, index) in ths" :key="index">{{ th }}</th>
              </tr>
              <tr v-for="item in cartLists" :key="item.id" class="tr "
                :class="{ 'active': isActive == item.product.id, }">
                <td>{{ item.product.name }}</td>
                <td>{{ item.product.weight * item.quantity }}</td>
                <td>
                  <el-input-number v-model="item.quantity" size="mini" style="max-width: 7rem;" @change="edit(item)"
                    :disabled="item.product.status != 10 || !item.product.stock" :min="1"
                    :max="item.product.stock"></el-input-number>
                </td>
                <td>{{ item.product.price }}</td>
                <td>{{ (item.product.price * item.quantity).toFixed(2) }}</td>
                <td @click.stop="del(item)">
                  <span class="iconfont icon-shanchu"></span>
                </td>
              </tr>
            </table>
          </div>
          <div class="text-gray-500 space-x-5 flex items-start pt-3 pl-3">
            <span>{{ $t('品类') }}:{{ total.category }}</span>
            <span>{{ $t('数量') }}:{{ total.quantity }}</span>
            <span>{{ $t('估重') }}:{{ total.weight }}kg</span>
          </div>
          <div class="flex items-start flex-col">
            <div class="subtitle">{{ $t('收货信息') }}</div>
            <div v-if="address && address.id" class="pl-2 pt-3">
              <div class="flex items-center">
                <span class="iconfont icon-shouhuodi text-main font-bold"></span>
                <span class="pl-1 pr-2">{{ address.receiver }}</span>
                <span class="text-gray-400">{{ address.phone }}</span>
              </div>
              <div>
                {{ address.address }}
              </div>
            </div>
          </div>
          <div class="flex items-start flex-col">
            <div class="subtitle">{{ $t('总额') }}</div>
            <div class="flex flex-col space-y-2 pt-2 pl-2">
              <span>{{ $t('商品总额') }}:{{ $p(total.price) }}</span>
              <span>{{ $t('实际付款') }}:<span class="text-red-500">{{ $p(total.price) }}</span></span>
            </div>
          </div>
          <div class="flex justify-start pl-2 py-5">
            <el-button type="danger" @click="submitOrder">{{ $t('提交订单') }}</el-button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, computed, onBeforeUnmount } from "@vue/composition-api"
export default {
  props: {
    products: Object,
    pager: Object,
    address: Object
  },
  setup(props, ctx) {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';
    const orderby = ref('')
    const orderbys = [
      {
        'name': ctx.root.$t('价格'),
        'key': 'price'
      },
      {
        'name': ctx.root.$t('库存'),
        'key': 'stock'
      },
      {
        'name': ctx.root.$t('销量'),
        'key': 'sales'
      }
    ]
    const selectOrderby = (key) => {
      if (!orderby.value.includes(key)) {
        orderby.value = key
      } else {
        if (orderby.value == key) {
          orderby.value = '-' + key
        } else {
          orderby.value = ''
        }
      }
      ctx.emit('sort', orderby.value)
    }
    const ths = [ctx.root.$t('品名'), ctx.root.$t('重量'), ctx.root.$t('数量'), ctx.root.$t('单价'), ctx.root.$t('金额'), ctx.root.$t('删除')]
    const cartLists = ref([])
    const getCartList = async () => {
      let res = await ctx.root.$callapi('trade/getMyCartList')
      if (res.code == 0 && res.data) {
        cartLists.value = res.data
      }
    }
    getCartList()
    // const address = ref()
    // const user = computed(() => ctx.root.$store.getters.user);
    // const getLockAddress = async () => {
    //   let res = await ctx.root.$callapi('user/getAddress', {
    //     aid: user.value?.user_lock_address
    //   })
    //   if (res.code == 0 && res.data) {
    //     address.value = res.data
    //   }
    // }
    // getLockAddress()

    const total = computed(() => {
      let obj = {}
      let priceArr = []
      let weightArr = []
      let quantityArr = []
      cartLists.value.map(item => {
        priceArr.push(item.quantity * item.product.price)
        quantityArr.push(item.quantity)
        weightArr.push(item.quantity * item.product.weight)
      })

      obj.price = priceArr.reduce((a, b) => a + b, 0)?.toFixed(2)
      obj.category = cartLists.value.length
      obj.quantity = quantityArr.reduce((a, b) => a + b, 0)
      obj.weight = weightArr.reduce((a, b) => a + b, 0)?.toFixed(2)

      return obj
    })

    const editQuantity = async (quantity, pid) => {
      let res = await ctx.root.$callapi('trade/editWithCart', { quantity, pid })
      if (res.code == 0 && res.data) {
        return res.data
      }
    }
    const isActive = ref()
    const addCart = async (item) => {
      if (item.status != 10) {
        return ctx.root.$toast(ctx.root.$t('商品已下架'))
      }
      if (!item.stock) {
        return ctx.root.$toast(ctx.root.$t('商品已售罄'))
      }
      let index = cartLists.value?.findIndex((i) => i.product.id == item.id)
      if (index > -1) {
        if (scroll.value) {
          scroll.value.scrollTo({
            top: scrollChild.value?.children[index + 1].offsetTop - scroll.value?.clientHeight + scrollChild.value?.children[index + 1].clientHeight,
            behavior: 'smooth'
          })
        }
        isActive.value = item.id;
        let target = cartLists.value[index]

        if (target.quantity < item.stock) {
          target.quantity++
          await editQuantity(target.quantity, item.id)
        } else {
          ctx.root.$toast(ctx.root.$t('商品库存不足'))
        }
        setTimeout(() => {
          isActive.value = "";
        }, 600);
      } else {
        let res = await editQuantity(1, item.id)
        cartLists.value.push(res)
        ctx.root.$nextTick(() => {
          if (scroll.value) {
            scroll.value.scrollTo({
              top: scroll.value.scrollHeight - scroll.value.clientHeight,
              behavior: 'smooth'
            })
          }
        })
      }

    }
    const scroll = computed(() => {
      return ctx.refs.scroll
    })
    const scrollChild = computed(() => {
      return ctx.refs.scrollChild
    })

    const edit = async (item) => {
      await editQuantity(item.quantity, item.product.id)
    }

    const del = async (item) => {
      let res = await editQuantity(-1, item.product.id)
      if (res) {
        let index = cartLists.value.findIndex(i => i.id == item.id)
        cartLists.value.splice(index, 1)
      }
    }


    //吸顶
    const isFixedTop = ref(false);
    const isFixedBottom = ref(false);



    const initHeight = () => {
      const productsHeight = computed(() => {
        return ctx.refs.products?.offsetHeight;
      })
      const productsTop = computed(() => {
        return ctx.refs.products?.offsetTop;

      })
      const bottomHeight = computed(() => {
        return scrollHeight.value - productsTop.value - productsHeight.value - 200
      })
      const scrollHeight = computed(() => {
        return document.body.scrollHeight
      })
      const offsetTop = computed(() => {
        return ctx.refs.orderBlank?.offsetTop;
      });
      const offsetHeight = computed(() => {
        return ctx.refs.boxFixed?.offsetHeight
      })
      const scrollTop = computed(() => {
        return window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      })
      isFixedTop.value =
        (scrollTop.value > offsetTop.value) && (scrollTop.value < scrollHeight.value - offsetHeight.value - bottomHeight.value)
          ? true
          : false;
      isFixedBottom.value =
        scrollTop.value >= scrollHeight.value - offsetHeight.value - bottomHeight.value ? true : false;
      // console.log(scrollHeight.value, offsetHeight.value, bottomHeight.value);
      // console.log(scrollHeight.value - offsetHeight.value - bottomHeight.value, scrollTop.value);
    };
    onMounted(() => {
      window.addEventListener("scroll", initHeight);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("scroll", initHeight);
    });

    const submitOrder = (async () => {
      let targetArr = cartLists.value.filter(item => item.product.status == 10 && item.product.stock)
      if (!targetArr.length) {
        return ctx.root.$toast(ctx.root.$t('没有可结算的商品'))
      }
      let cids = targetArr.map(i => i.id)
      let sids = [...new Set(targetArr.map(i => i.product.supplier_info.sid))]
      ctx.root.$router.push({
        path: "/product/dealOrder",
        query: {
          cids: cids.join(','),
          sids: sids.join(',')
        }
      })
    })

    const pageChange = async (page) => {
      ctx.emit('more', page)
    }


    return { orderbys, orderby, selectOrderby, ths, cartLists, total, defaultUrl, isFixedTop, isFixedBottom, addCart, isActive, edit, del, submitOrder, pageChange }
  }
}
</script>
<style scoped lang="scss">.orderbys .iconfont {
  transition: all 0.3s;
}
.orderbys .iconfont.up {
  display: block;
  transform: rotate(-180deg);
}
.products {
  display: grid;
  grid-template-columns: calc(100% - 32rem) 32rem;
  grid-column-gap: 1.07rem;
}
.products .left {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0.86rem;
}
.products .left .product {
  border-radius: 0.29rem;
  max-height: 26rem;
  overflow: hidden;
}
.products .left .product .img-box {
  position: relative;
  width: 100%;
  height: 0px;
  padding-top: 100%;
}
.products .left .product .img-box .img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.products .left .product .price {
  color: #F20303;
}
.products .right .tables {
  overflow-y: scroll;
  max-height: 40vh;
  overflow-x: hidden;
}
.products .right .tables table {
  width: 100%;
  border-collapse: collapse;
}
.products .right .tables table, .products .right .tables th, .products .right .tables td {
  border: 0.02rem solid #D7D7D7;
}
.products .right .tables th {
  padding: 0.6rem 0;
  white-space: nowrap;
  overflow: hidden;
}
.products .right .tables td {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 0;
}
.products .right .tables .tr {
  display: grid;
  grid-template-columns: 2fr 1fr 2.5fr 1fr 1fr 1fr;
}
.products .right .tables .tr.active {
  animation: bounce-up 0.3s linear infinite;
}
.products .right .subtitle {
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.75rem;
  margin-top: 0.75rem;
  width: 100%;
  background-color: #F2F2F2;
  padding: 0.4rem;
  text-align: left;
}
.products .right .is_fixed_top {
  position: fixed;
  top: 0rem;
  width: 32rem;
  z-index: 9;
}
.products .right .is_fixed_bottom {
  position: fixed;
  bottom: 37rem;
  width: 32rem;
  z-index: 9;
}
.status {
  background-color: rgba(0, 0, 0, 0.4);
  color: #ffffff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.status .iconfont {
  font-size: 4rem;
}</style>